export const ExternalSwitches = {
  WEB_ATTRIBUTION_SURVEY: "web_attribution_survey",
  SCHOOLS_PAGE: "web_schools_page_2023",
} as const;

export const featureSwitches = Object.values(ExternalSwitches);
